<template>
    <div class="piscreen">
        
        <PlayerSelection v-if="!playerChosen" v-on:player-chosen="setPlayer" :darkmode="true"></PlayerSelection>
        <StatusMessage v-if="statusMessage" :message="statusMessage" category="" :redirect="true"></StatusMessage>

        <div class="topBar">
            <div class="home">
                <a href="/"><font-awesome-icon icon="home" /></a>
            </div>
            <div class="home">
                <a href="/leaderboard"><font-awesome-icon icon="trophy" /></a>
            </div>
            <div class="home active">
                <a href="/playeroptions"><font-awesome-icon icon="user-cog" /></a>
            </div>
            <div class="home">
                <a href="/playermilestones"><font-awesome-icon icon="user-check" /></a>
            </div>
        </div>

        <div class="titleSelection">
            <div class="header">
                <div class="description">
                    <h2>Kies je titel</h2>
                    <p>Je titel wordt weergegeven op het leaderboard</p>
                </div>
                <div class="saveButton gray invisBorder" v-bind:class="{ gold: settingChanged }" @click="saveChanges()">
                    Save
                </div>
            </div>

            <div class="titles">
                <div class="title" v-for="title in titles" v-bind:class="{ activeTitle: title.active }" @click="activateTitle(title)">
                    <div class="titleIcon">
                        <font-awesome-icon :icon="title.icon" v-if="title.icon" />
                    </div>
                    <div class="titleInfo">
                        <h3 v-bind:class="{ gray: !title.enabled }">{{ title.name }}</h3>
                        <p v-bind:class="{ green: title.unlocked, red: !title.unlocked, gray: !title.enabled }">{{ title.description }}</p>
                    </div>
                </div>
            </div>
            
        </div>

        
    </div>
</template>

<script>

import axios from 'axios'
import StatusMessage from './partials/StatusMessage'
import PlayerSelection from './partials/PlayerSelection'


export default {

    name: 'PlayerOptions',

    components: {
        StatusMessage: StatusMessage,
        PlayerSelection: PlayerSelection
    },

    data() {
        return {
            settingChanged: false,
            playerChosen: false,
            currentTitle: '',
            newTitle: '',
            statusMessage: '',
            player: {
                id: '',
                name: '',
                title: ''
            },
            season: {
                id: '',
                name: ''
            },
            titles: {
                none: {
                    id: 1,
                    name: 'Geen titel',
                    description: 'Hier begin je mee',
                    unlocked: true,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'ban'
                },
                singles: {
                    id: 2,
                    name: 'The Chosen One',
                    description: 'Gooi alle Singles',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'utensil-spoon'
                },
                doubles2x: {
                    id: 3,
                    name: 'Placeholder',
                    description: 'Gooi alle Doubles (2x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                doubles3x: {
                    id: 4,
                    name: 'Placeholder',
                    description: 'Gooi alle Doubles (3x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                triples2x: {
                    id: 5,
                    name: 'Placeholder',
                    description: 'Gooi alle Triples (2x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                triples3x: {
                    id: 6,
                    name: 'Placeholder',
                    description: 'Gooi alle Triples (3x)',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: false
                },
                shanghai: {
                    id: 7,
                    name: 'Shanghai Master',
                    description: 'Gooi alle Shanghais',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'dragon'
                },
                robinhood: {
                    id: 8,
                    name: 'The Destroyer',
                    description: 'Gooi alle Robin Hoods',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'skull'
                },
                bull: {
                    id: 9,
                    name: 'Dartkoning',
                    description: 'Gooi 3x de Bullseye in 1 beurt',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'crown'
                },
                all: {
                    id: 10,
                    name: 'Dartrobot',
                    description: 'Gooi alles in alle categorieën',
                    unlocked: false,
                    active: false,
                    score: 0,
                    enabled: true,
                    icon: 'robot'
                },
            },

            

        }
        
    },

    computed: {
        // totalScore() {
            
        //     let total = 0;

        //     total += this.titles.singles.score;
        //     total += this.titles.doubles2x.score;
        //     total += this.titles.doubles3x.score;
        //     total += this.titles.triples2x.score;
        //     total += this.titles.triples3x.score;
        //     total += this.titles.shanghai.score;
        //     total += this.titles.robinhood.score;
        //     total += this.titles.bull.score;
                


        //     return total;
        // }
    },

    methods: {
        saveChanges() {

            const params = new URLSearchParams();
            params.append('user_id', this.player.id);
            params.append('title', this.newTitle);

            let self = this;

            axios.post('/darts_db/users/update_user.php', params).then(function (response) {
                console.log(response);
                self.statusMessage = response.data;
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        activateTitle(title) {
            
            if (title.unlocked) {
                console.log(this.titles)
                this.settingChanged = true;

                for (var key of Object.keys(this.titles)) {
                    
                    if (this.titles[key].active) {
                        this.titles[key].active = false;
                        // TODO: send to db on save

                    }
                }
                
                this.newTitle = title.id;
                title.active = true;
                // TODO: send to db on save

                
            }
        },

        setPlayer(player) {
            this.player.id = player.id;
            this.player.name = player.name;
            if (player.title) {
                this.player.title = player.title;
            } else {
                this.player.title = 1;
                this.player.currentTitle = 1;
            }
            
            // this.loadMilestones(this.player.id);
            this.playerChosen = true;
            this.playerName = this.player.name;

            for (var key of Object.keys(this.titles)) {
                    
                if (this.titles[key].id == this.player.title) {
                    this.titles[key].active = true;
                    // TODO: send to db on save

                }
            }


            console.log(player.id)

            this.getSingles();
            this.getDoubles2x();
            this.getDoubles3x();
            this.getTriples2x();
            this.getTriples3x();
            this.getShanghai();
            this.getRobinhood();
            this.getBull();

        },

        getActiveSeason() {
            const params = {
                params: {
                    // user_id: '1'
                }
            }

            const self = this;
            axios.get('/darts_db/seasons/get_active_season.php', params).then(function (response) {
                console.log(response);
                self.season.id = response.data[0].id;
                self.season.name = response.data[0].name;
            }).catch(function (error) {
                console.log(error);
            });
            
        },

        getSingles() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'singles'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.singles.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    self.titles.singles.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles2x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'doubles_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.doubles2x.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    // self.titles.doubles2x.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getDoubles3x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'doubles_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.doubles3x.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    // self.titles.doubles3x.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples2x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'triples_2x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.triples2x.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    // self.titles.triples2x.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getTriples3x() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'triples_3x'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.triples3x.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    // self.titles.triples3x.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getShanghai() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'shanghai'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.shanghai.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 20) {
                    self.titles.shanghai.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getRobinhood() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'robinhood'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.robinhood.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                if (response.data.length == 22) {
                    self.titles.robinhood.unlocked = true;
                }
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        getBull() {

            const params = {
                params: {
                    user_id: this.player.id,
                    season_id: this.season.id,
                    category: 'bull'
                }
            }

            const self = this;

            axios.get('/darts_db/categories/get_all_from_category_by_user.php', params).then(function (response) {
                console.log(response);

                self.titles.bull.score = response.data.length;
                self.titles.all.score += response.data.length;
                self.unlockDartGod();

                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].score == 'RRR') {
                        self.titles.bull.unlocked = true;
                    }
                }
                
            }).catch(function (error) {
                console.log(error.response);
                self.statusMessage = error.data;;
            });
        },

        unlockDartGod() {
            if (this.titles.all.score == 151) {
                this.titles.all.unlocked = true;
            }
        }
        

        


    },



    mounted() {
        this.getActiveSeason();
        
    }
}
</script>


<style scoped>

    
    


    .piscreen {
        width: 800px;
        background: #444;
        min-height: 480px;
        color: #fff;
    }

    .topBar {

        background: #666;
        display: flex;
        height: 80px;
        /*align-items: center;*/
        /*border-bottom: 1px solid #bbb;*/

        box-shadow: 0px 1px 3px rgba(0,0,0,0.48);

    }
    .home {
        /*position: absolute;*/
        font-size: 32px;
        /*border: 1px solid #558b2f;*/
        border: 1px solid #222;
        margin: 10px 0 10px 10px;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.24);
        /*background: #aed581;*/
        background: #555;
        border-radius: 3px;
        /*height: 60px;*/
        left: 0px;
        top: 0px;
        cursor: pointer;
        user-select: none;
    }
    .home a {
        text-decoration: none;
        padding: 5px 15px 10px;
        display: block;
        color: #fff;
    }
    .active a {
        color: gold;
    }

    .titleSelection {
        /*padding: 0 10px 10px;*/
        padding: 10px 20px;
    }
    h2,
    h3 {
        font-weight: normal;
        text-transform: uppercase;
        margin: 0;
        /*text-shadow: 1px 1px 3px #000;*/
    }
    p {
        margin: 0;
    }
    .titles {
        margin-top: 10px;
        margin-left: 0px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 315px;
        width: 640px;
    }
    .title {
        /*margin-top: 10px;*/
        /*padding-left: 50px;*/
        display: flex;
        padding: 5px 5px 10px 10px;
        width: 300px;
        border: 1px solid rgba(0,0,0,0);
    }

    .red {
        color: #f22;
    }
    .green {
        color: #2f2;
    }
    .gray {
        color: #aaa;
    }
    .invisBorder {
        border: 1px solid rgba(0,0,0,0);
    }
    .gold {
        color: gold;
        border: 1px solid gold;
        text-shadow: 1px 1px 2px #444;
    }

    .activeTitle {
        border: 1px solid #0f0;
    }

    .header {
        display: flex;
        justify-content: space-between;
    }

    .saveButton {
        font-size: 2em;
        text-transform: uppercase;
        box-shadow: 1px 1px 3px rgba(0,0,0,0.5);
        background: #666;
        padding: 2px 20px 0;
        
        border-radius: 3px;
    }

    .titleInfo {
        margin-left: 10px;
    }

    .titleIcon {
        font-size: 2em;
        width: 40px;
        text-align: center;
    }

</style>
